import { CommunsModule } from './communs/communs.module';
import { AppModule } from './app.module';
import { HomeSocialComponent } from './home/home-social/home-social.component';
import { HomePropostasComponent } from './home/home-propostas/home-propostas.component';
import { HomeProjetosComponent } from './home/home-projetos/home-projetos.component';
import { HomePesquisaComponent } from './home/home-pesquisa/home-pesquisa.component';
import { HomeGaleriaComponent } from './home/home-galeria/home-galeria.component';
import { HomeBlogComponent } from './home/home-blog/home-blog.component';
import { VideosComponent } from './videos/videos.component';
import { PropostasComponent } from './propostas/propostas.component';
import { ProjetosComponent } from './projetos/projetos.component';
import { PesquisaComponent } from './pesquisa/pesquisa.component';
import { HeaderComponent } from './header/header.component';
import { GaleriaComponent } from './galeria/galeria.component';
import { FotosDaCampanhaComponent } from './fotos-da-campanha/fotos-da-campanha.component';
import { FooterComponent } from './footer/footer.component';
import { EventosComponent } from './eventos/eventos.component';
import { BlogComponent } from './blog/blog.component';
import { BibliografiaComponent } from './bibliografia/bibliografia.component';
import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';

import { PublicRoutingModule } from './public-routing.module';
import { PublicComponent } from './public.component';
import { HomeComponent } from './home/home/home.component';
import { TimelineComponent } from './timeline/timeline.component';
import { HomeBannerComponent } from './home/home-banner/home-banner.component';
import { HomeEventosComponent } from './home/home-eventos/home-eventos.component';
import { HomeFotoscampanhaComponent } from './home/home-fotoscampanha/home-fotoscampanha.component';

@NgModule({
  imports: [
    CommonModule, CommunsModule,
    PublicRoutingModule
  ],
  declarations: [PublicComponent,
    BibliografiaComponent,
    BlogComponent,
    EventosComponent,
    FooterComponent,
    FotosDaCampanhaComponent,
    GaleriaComponent,
    HeaderComponent,
    HomeComponent,
    HomeBannerComponent,
    HomeBlogComponent,
    HomeEventosComponent,
    HomeFotoscampanhaComponent,
    HomeGaleriaComponent,
    HomePesquisaComponent,
    HomeProjetosComponent,
    HomePropostasComponent,
    HomeSocialComponent,
    PesquisaComponent,
    ProjetosComponent,
    PropostasComponent,
    TimelineComponent,
    VideosComponent]
  })
export class PublicModule { }



// WEBPACK FOOTER //
// ./src/app/public.module.ts